import { Box, Button, Dialog, Stack, Typography, pn } from "@compass/core";
import { Input } from "components";
import { StudentService, StudentServiceViewResource, UploadFile } from "generated/openApi";
import produce from "immer";
import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import ApiService from "services/apiService";
import { initDataModel } from "utils";

export const StaffSignature = (props: {
  open: boolean;
  close: () => void;
  service: StudentService;
  done: (value: StudentService) => void;
}) => {
  const [viewResource, setViewResource] = useState<StudentServiceViewResource>({});
  const properties = viewResource.properties || [];

  const [service, setService] = useState<StudentService>(props.service);
  const signatureRef = useRef<SignatureCanvas>(null);
  const validated = service.staffName && signatureRef.current && signatureRef.current.isEmpty() === false;
  const [, forceUpdate] = useState<any>();

  useEffect(() => {
    ApiService.studentServices.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  useEffect(() => {
    setService(props.service);
  }, [props.service]);

  const done = () => {
    let _service = { ...service };
    _service.staffSignatureUploadFile = initDataModel<UploadFile>({
      fileName: "Staff_Signature.png",
      fileSize: undefined,
      uploadingData: signatureRef?.current?.getTrimmedCanvas().toDataURL("image/png"),
    });
    props.done(_service);
  };

  const clearSignature = () => {
    signatureRef.current?.clear();
    forceUpdate({});
  };

  const staffNameField = () => {
    const propertyName = pn<StudentService>("staffName");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Input
        modelProperty={property}
        value={service.staffName}
        onChange={(e) =>
          setService(
            produce(service, (draft) => {
              draft.staffName = e.target.value;
            })
          )
        }
      />
    );
  };

  const signatureField = () => {
    const propertyName = pn<StudentService>("staffSignatureUploadFileId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Stack>
        <Typography variant="inherit">
          To the best of my knowledge, the information is verified as accurate and complete.
        </Typography>

        <Stack
          border={1}
          borderColor={(theme) => theme.palette.border.dark}
          spacing="sm"
          bgcolor={(theme) => theme.palette.background.default}
          alignItems="center"
        >
          <Box sx={{ width: 350, height: 200 }} bgcolor={(theme) => theme.palette.background.paper}>
            <SignatureCanvas
              penColor="black"
              ref={signatureRef}
              canvasProps={{ width: 350, height: 200 }}
              onEnd={() => forceUpdate({})}
            />
          </Box>
        </Stack>

        <Stack direction="row" justifyContent={"flex-end"} alignItems="center">
          <Button onClick={() => clearSignature()}>Clear</Button>
        </Stack>
      </Stack>
    );
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      header={
        <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
          <Typography variant="inherit">Staff Signature</Typography>
          <Stack direction="row" spacing="sm">
            <Button onClick={() => props.close()}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                done();
                props.close();
              }}
              disabled={!validated}
            >
              Add
            </Button>
          </Stack>
        </Stack>
      }
      content={
        <Stack spacing="sm">
          {staffNameField()}

          {signatureField()}
        </Stack>
      }
    />
  );
};
